/**
 * Month-overview payload keys used when reading from raw records.
 * Use these instead of string literals so typos are caught at compile time.
 */
export const PARAGRAPH1_KEYS = {
  DEFAULT: "default",
  POSITIVE_WITH_SAVINGS: "positiveWithSavings",
  POSITIVE_WITH_PERFECT_SAVINGS: "positiveWithPerfectSavings",
  POSITIVE_WITH_NEGATIVE_SAVINGS: "positiveWithNegativeSavings",
  POSITIVE_WITH_NO_SAVINGS: "positiveWithNoSavings",
  NEGATIVE_WTH_NEGATIVE_SAVINGS: "negativeWthNegativeSavings",
} as const;

export const PARAGRAPH2_KEYS = {
  LOAN_AND_CREDIT_CARD: "loanAndCreditCard",
  ONLY_CREDIT_CARD: "onlyCreditCard",
  ONLY_LOAN: "onlyLoan",
} as const;

export const MONEY_IN_KEYS = {
  OTHER: "other",
  LOAN: "loan",
  OTHER_AND_LOAN: "otherAndLoan",
  ZERO: "zero",
} as const;

export const MONEY_OUT_KEYS = {
  OTHER: "other",
  CREDIT_CARD: "creditCard",
  LOAN: "loan",
  OTHER_AND_LOAN: "otherAndLoan",
  OTHER_AND_CREDIT_CARD: "otherAndCreditCard",
  LOAN_AND_CREDIT_CARD: "loanAndCreditCard",
  OTHER_AND_LOAN_AND_CREDIT_CARD: "otherAndLoanAndCreditCard",
  ZERO: "zero",
} as const;

export const CREDIT_CARD_KEYS = {
  NEGATIVE_TRANSACTIONS: "negativeTransactions",
  PAYMENTS: "payments",
  PAYMENTS_AND_NEGATIVE_TRANSACTIONS: "paymentsAndNegativeTransactions",
} as const;

export const MONTHLY_OVERVIEW_RECORD_KEYS = {
  MONEY_IN: "moneyIn",
  MONEY_OUT: "moneyOut",
  CREDIT_CARD: "creditCard",
  SAVINGS: "savings",
} as const;

export const MONTH_OVERVIEW_DETAILS_PARSED_KEYS = {
  PARAGRAPH1: "paragraph1",
  PARAGRAPH2: "paragraph2",
  PARAGRAPH3: "paragraph3",
} as const;
